module.exports = __webpack_public_path__ + "fonts/GothamSSm-BoldItalic.ab8ee6da.eot";